(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["circular-category-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const sliders = document.querySelectorAll('.ccs');
    if (!sliders.length) return;

    sliders.forEach((slider) => {
      const track = slider.querySelector('[data-ccs-track]');
      const prevBtn = slider.querySelector('[data-ccs-prev]');
      const nextBtn = slider.querySelector('[data-ccs-next]');
      if (!track) return;

      const isTouch = matchMedia('(hover: none) and (pointer: coarse)').matches;

      const updateOverflow = () => {
        const overflows = track.scrollWidth > track.clientWidth + 1;
        track.classList.toggle('is-overflowing', overflows);
        if (!isTouch && prevBtn && nextBtn) {
          prevBtn.hidden = !overflows;
          nextBtn.hidden = !overflows;
        }
      };

      const updateNav = () => {
        if (!prevBtn || !nextBtn || prevBtn.hidden) return;
        const max = track.scrollWidth - track.clientWidth;
        prevBtn.disabled = track.scrollLeft <= 2;
        nextBtn.disabled = track.scrollLeft >= max - 2;
      };

      const scrollByAmount = () => {
        const item = track.querySelector('.ccs__item');
        if (!item) return track.clientWidth * 0.8;
        const style = getComputedStyle(track);
        const gap = parseFloat(style.gap) || 16;
        const visibleCount = Math.max(1, Math.floor(track.clientWidth / (item.offsetWidth + gap)));
        return (item.offsetWidth + gap) * visibleCount;
      };

      prevBtn?.addEventListener('click', () => {
        track.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
      });
      nextBtn?.addEventListener('click', () => {
        track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', () => { updateOverflow(); updateNav(); });

      updateOverflow();
      updateNav();
      track.querySelectorAll('img').forEach(img => {
        if (!img.complete) img.addEventListener('load', () => { updateOverflow(); updateNav(); }, { once: true });
      });

      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          track.scrollBy({ left: -scrollByAmount(), behavior: 'smooth' });
        }
      });

      /* Drag-to-scroll: lazy activation.
         We do NOT install global mousemove/mouseup handlers, and we do NOT
         touch click events. We listen for mousedown, and only if the user
         moves more than the threshold do we (a) start scrolling and (b)
         install temporary window listeners that we remove on mouseup.
         A genuine click (no movement) is never touched, so links work. */
      if (!isTouch) {
        const DRAG_THRESHOLD = 6;

        track.addEventListener('mousedown', (e) => {
          /* Ignore right-click, middle-click, modifier keys */
          if (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey) return;

          const startX = e.pageX;
          const startScroll = track.scrollLeft;
          let dragging = false;

          const onMove = (ev) => {
            const dx = ev.pageX - startX;
            if (!dragging && Math.abs(dx) > DRAG_THRESHOLD) {
              dragging = true;
              track.style.cursor = 'grabbing';
              track.style.scrollBehavior = 'auto';
            }
            if (dragging) {
              ev.preventDefault();
              track.scrollLeft = startScroll - dx;
            }
          };

          const onUp = () => {
            window.removeEventListener('mousemove', onMove);
            window.removeEventListener('mouseup', onUp);

            if (dragging) {
              track.style.cursor = '';
              track.style.scrollBehavior = '';
              /* Block ONLY the immediate click that browser fires after this drag,
                 then auto-remove the listener so future clicks navigate normally. */
              const swallow = (ev) => {
                ev.preventDefault();
                ev.stopPropagation();
              };
              window.addEventListener('click', swallow, { capture: true, once: true });
              /* Safety: if no click event fires, remove the listener after 100ms */
              setTimeout(() => window.removeEventListener('click', swallow, true), 100);
            }
          };

          window.addEventListener('mousemove', onMove);
          window.addEventListener('mouseup', onUp);
        });
      }

      const autoplay = slider.dataset.autoplay === 'true';
      const speed = parseInt(slider.dataset.autoplaySpeed, 10) || 4000;

      if (autoplay && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        let timer = null;
        const tick = () => {
          if (!track.classList.contains('is-overflowing')) return;
          const max = track.scrollWidth - track.clientWidth;
          if (track.scrollLeft >= max - 2) {
            track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            track.scrollBy({ left: scrollByAmount(), behavior: 'smooth' });
          }
        };
        const start = () => { stop(); timer = setInterval(tick, speed); };
        const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
        start();
        slider.addEventListener('mouseenter', stop);
        slider.addEventListener('mouseleave', start);
        track.addEventListener('focusin', stop);
        track.addEventListener('focusout', start);
        document.addEventListener('visibilitychange', () => {
          document.hidden ? stop() : start();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
